export default "__VITE_ASSET__1e3119a2__"